var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#F58634",
    height: "64px",
    width: "64px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.00 512.00",
    xmlSpace: "preserve",
    stroke: "#F58634",
    strokeWidth: 0.00512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 2.048
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.478,139.13H16.696C7.479,139.13,0,146.603,0,155.826v333.913c0,9.223,7.479,16.696,16.696,16.696h66.783 c9.217,0,16.696-7.473,16.696-16.696V155.826C100.174,146.603,92.695,139.13,83.478,139.13z M50.089,439.652 c-9.212,0-16.696-7.484-16.696-16.696s7.484-16.696,16.696-16.696s16.696,7.484,16.696,16.696S59.302,439.652,50.089,439.652z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M512,222.609c0-27.619-22.468-50.087-50.087-50.087H334.054c21.989-51.386,18.391-114.603,18.228-116.87 c0-27.619-22.468-50.087-50.087-50.087s-50.087,22.468-50.087,50.087c0,44.07-26.75,84.749-66.554,101.222l-41.673,17.233 c-6.24,2.581-10.316,8.674-10.316,15.429v266.81c0,9.223,7.479,16.696,16.696,16.696h211.478 c27.619,0,50.087-22.468,50.087-50.087c0-6.511-1.25-12.739-3.522-18.451c21.25-5.799,36.913-25.272,36.913-48.332 c0-6.511-1.25-12.739-3.522-18.451c21.25-5.799,36.913-25.272,36.913-48.332c0-6.511-1.25-12.739-3.522-18.45 C496.337,265.142,512,245.669,512,222.609z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeRed);
export default __webpack_public_path__ + "static/media/likeRed.76e0808c485d52f3a60d6d6265525986.svg";
export { ForwardRef as ReactComponent };